/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]:not(.foriba-loader){width:100%!important;position:absolute!important;top:0!important;left:0!important;height:100%!important;background-color:#fff!important;display:flex!important;justify-content:center!important;align-items:center!important;z-index:1000;opacity:.5}.foriba-loader[_ngcontent-%COMP%]{width:100%;height:100%;position:absolute;top:50%;left:45%;margin:-32px 0 0 -70px;display:inline-block;vertical-align:middle;background:url(dots.fb749a2f2751fb60487a.gif) no-repeat}"];
export { styles as styles };
